import { Injectable } from '@angular/core';
import { ApiCallService } from '../../core/services/api/api-call.service';
import { IReportSpotCondition } from '../interfaces/report-spot-condition';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';

@Injectable({
  providedIn: 'root',
})
export class ReportSpotConditionService {
  constructor(private apiCall: ApiCallService, private http: HttpClient, private urlBuilderService: UrlBuilderService) {}

  public getConditionReport(params: any): Promise<{ error: any; data: IReportSpotCondition[] }> {
    const url = 'Report/GetConditionReport';
    return this.apiCall.get(url, { params });
  }

  public getConditionReportExcel(params: any): Observable<any> {
    const url = `${this.urlBuilderService.apiUrl}/Report/GetConditionReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }
}
